export const LANGUAGE_NAMES: Record<string, string> = {
  cs: 'Čeština',
  en: 'English',
  vi: 'Tiếng Việt',
};
